// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet communicatie-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { BestandenBestandToevoegenBody } from '../model/bestandenBestandToevoegenBody';

import type { CollectionResultOfDocumentenDocumentenGetDocumentenDto } from '../model/collectionResultOfDocumentenDocumentenGetDocumentenDto';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';

import type { SUREbusinessCommonDomainEntityReferencesSbEntityType } from '../model/sUREbusinessCommonDomainEntityReferencesSbEntityType';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Communicatie.BestandenUploaden</li></ul>
 * @summary Voeg een bestand toe aan de gekozen entity.
 */
export const bestandenBestandToevoegen = (
  type: MaybeRef<SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null>,
  id: MaybeRef<string | undefined | null>,
  bestandenBestandToevoegenBody?: MaybeRef<BestandenBestandToevoegenBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  type = unref(type);
  id = unref(id);
  bestandenBestandToevoegenBody = unref(bestandenBestandToevoegenBody);
  const formData = new FormData();
  if (bestandenBestandToevoegenBody?.['Dto.Bestandsnaam'] !== undefined) {
    formData.append(`Dto.Bestandsnaam`, bestandenBestandToevoegenBody['Dto.Bestandsnaam']);
  }
  if (bestandenBestandToevoegenBody?.['Dto.Toelichting'] !== undefined) {
    formData.append(`Dto.Toelichting`, bestandenBestandToevoegenBody['Dto.Toelichting']);
  }
  if (bestandenBestandToevoegenBody?.['Dto.IsGeheim'] !== undefined) {
    formData.append(`Dto.IsGeheim`, bestandenBestandToevoegenBody['Dto.IsGeheim'].toString());
  }
  if (bestandenBestandToevoegenBody?.['Dto.DocumentType'] !== undefined) {
    formData.append(`Dto.DocumentType`, bestandenBestandToevoegenBody['Dto.DocumentType']);
  }
  if (bestandenBestandToevoegenBody?.File !== undefined) {
    formData.append(`File`, bestandenBestandToevoegenBody.File);
  }

  return customInstance<string>(
    {
      url: `/api/v1/communicatie/Bestanden/${type}/${id}`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getBestandenBestandToevoegenMutationOptions = <
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bestandenBestandToevoegen>>,
    TError,
    {
      type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
      id: string | undefined | null;
      data?: BestandenBestandToevoegenBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bestandenBestandToevoegen>>,
  TError,
  {
    type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
    id: string | undefined | null;
    data?: BestandenBestandToevoegenBody;
  },
  TContext
> => {
  const mutationKey = ['bestandenBestandToevoegen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bestandenBestandToevoegen>>,
    {
      type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
      id: string | undefined | null;
      data?: BestandenBestandToevoegenBody;
    }
  > = (props) => {
    const { type, id, data } = props ?? {};

    return bestandenBestandToevoegen(type, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BestandenBestandToevoegenMutationResult = NonNullable<
  Awaited<ReturnType<typeof bestandenBestandToevoegen>>
>;
export type BestandenBestandToevoegenMutationBody = BestandenBestandToevoegenBody | undefined;
export type BestandenBestandToevoegenMutationError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails | void
>;

/**
 * @summary Voeg een bestand toe aan de gekozen entity.
 */
export const useBestandenBestandToevoegen = <
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bestandenBestandToevoegen>>,
      TError,
      {
        type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
        id: string | undefined | null;
        data?: BestandenBestandToevoegenBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof bestandenBestandToevoegen>>,
  TError,
  {
    type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
    id: string | undefined | null;
    data?: BestandenBestandToevoegenBody;
  },
  TContext
> => {
  return useMutation(getBestandenBestandToevoegenMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Communicatie.BestandenInzien</li></ul>
 * @summary Haal alle bestanden op voor de gekozen entity.
 */
export const bestandenBestandenOphalen = (
  type: MaybeRef<SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null>,
  id: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  type = unref(type);
  id = unref(id);

  return customInstance<CollectionResultOfDocumentenDocumentenGetDocumentenDto>(
    { url: `/api/v1/communicatie/Bestanden/${type}/${id}`, method: 'GET', signal },
    options,
  );
};

export const getBestandenBestandenOphalenQueryKey = (
  type: MaybeRef<SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null>,
  id: MaybeRef<string | undefined | null>,
) => {
  return ['api', 'v1', 'communicatie', 'Bestanden', type, id] as const;
};

export const getBestandenBestandenOphalenQueryOptions = <
  TData = Awaited<ReturnType<typeof bestandenBestandenOphalen>>,
  TError = ErrorType<void>,
>(
  type: MaybeRef<SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null>,
  id: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bestandenBestandenOphalen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getBestandenBestandenOphalenQueryKey(type, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bestandenBestandenOphalen>>> = ({
    signal,
  }) => bestandenBestandenOphalen(type, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () =>
        unref(type) !== null &&
        unref(type) !== undefined &&
        unref(id) !== null &&
        unref(id) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof bestandenBestandenOphalen>>, TError, TData>;
};

export type BestandenBestandenOphalenQueryResult = NonNullable<
  Awaited<ReturnType<typeof bestandenBestandenOphalen>>
>;
export type BestandenBestandenOphalenQueryError = ErrorType<void>;

/**
 * @summary Haal alle bestanden op voor de gekozen entity.
 */

export function useBestandenBestandenOphalen<
  TData = Awaited<ReturnType<typeof bestandenBestandenOphalen>>,
  TError = ErrorType<void>,
>(
  type: MaybeRef<SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null>,
  id: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bestandenBestandenOphalen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBestandenBestandenOphalenQueryOptions(type, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Communicatie.BestandenVerwijderen</li></ul>
 * @summary Verwijdert een bestand.
 */
export const bestandenBestandVerwijderen = (
  type: MaybeRef<SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null>,
  id: MaybeRef<string | undefined | null>,
  documentId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  type = unref(type);
  id = unref(id);
  documentId = unref(documentId);

  return customInstance<void>(
    { url: `/api/v1/communicatie/Bestanden/${type}/${id}/${documentId}`, method: 'DELETE', signal },
    options,
  );
};

export const getBestandenBestandVerwijderenMutationOptions = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bestandenBestandVerwijderen>>,
    TError,
    {
      type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
      id: string | undefined | null;
      documentId: string | undefined | null;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bestandenBestandVerwijderen>>,
  TError,
  {
    type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
    id: string | undefined | null;
    documentId: string | undefined | null;
  },
  TContext
> => {
  const mutationKey = ['bestandenBestandVerwijderen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bestandenBestandVerwijderen>>,
    {
      type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
      id: string | undefined | null;
      documentId: string | undefined | null;
    }
  > = (props) => {
    const { type, id, documentId } = props ?? {};

    return bestandenBestandVerwijderen(type, id, documentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BestandenBestandVerwijderenMutationResult = NonNullable<
  Awaited<ReturnType<typeof bestandenBestandVerwijderen>>
>;

export type BestandenBestandVerwijderenMutationError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Verwijdert een bestand.
 */
export const useBestandenBestandVerwijderen = <
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bestandenBestandVerwijderen>>,
      TError,
      {
        type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
        id: string | undefined | null;
        documentId: string | undefined | null;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof bestandenBestandVerwijderen>>,
  TError,
  {
    type: SUREbusinessCommonDomainEntityReferencesSbEntityType | undefined | null;
    id: string | undefined | null;
    documentId: string | undefined | null;
  },
  TContext
> => {
  return useMutation(getBestandenBestandVerwijderenMutationOptions(options), queryClient);
};
